const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/roles/create.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";
export const Route = createFileRoute("/client/roles/create")({
  beforeLoad: args => requirePermission(Permissions.ClientUsers.ManageRoles, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
const roleSchema = z.object({
  roleName: z.string().min(1, "Role name is required"),
  isActive: z.boolean()
});
type RoleFormValues = z.infer<typeof roleSchema>;